var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SalesForceImportConfig_1;
import { DateConverter, JSON, JsonConverter, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { ImportOperation } from '../importTask';
import { ImportConfig, ImportConfigType } from './importConfig';
import { salesForceImportConfigSchemaValidation } from '../../validations.generated';
export var SalesForceSourceType;
(function (SalesForceSourceType) {
    SalesForceSourceType["Object"] = "object";
    SalesForceSourceType["Report"] = "report";
})(SalesForceSourceType || (SalesForceSourceType = {}));
export const salesForceImportConfigSchema = {
    $id: 'urn:wisepipe-common-data:SalesForceImportConfig',
    type: 'object',
    properties: {
        startDate: { type: 'string', format: 'date-time' },
        sourceType: {
            type: 'string',
            enum: Object.values(SalesForceSourceType)
        },
        objectName: { type: 'string', minLength: 1 },
        reportId: { type: 'string', minLength: 1 }
    },
    // sourceType determines required ID type
    if: { properties: { sourceType: { const: SalesForceSourceType.Object } }, required: ['sourceType'] },
    then: { required: ['objectName'] },
    else: {
        if: { properties: { sourceType: { const: SalesForceSourceType.Report } }, required: ['sourceType'] },
        then: { required: ['reportId'] }
    },
    required: ['startDate']
};
let SalesForceImportConfig = SalesForceImportConfig_1 = class SalesForceImportConfig extends ImportConfig {
    constructor(startDate, sourceType, objectName, reportId, columnsToUpdate) {
        super(ImportConfigType.SalesForce, columnsToUpdate);
        this.startDate = startDate;
        this.sourceType = sourceType;
        this.objectName = objectName;
        this.reportId = reportId;
        JSON.validate(this, SalesForceImportConfig_1);
    }
    get supportedRefreshOperations() {
        return [ImportOperation.Overwrite];
    }
    get needsDiscovery() {
        return true;
    }
    get supportTapFilter() {
        // Reports do not support source filtering
        if (this.sourceType === SalesForceSourceType.Report || this.filters === undefined)
            return false;
        // should only have one stream for salesforce
        const importFilters = Array.from(this.filters.values());
        return importFilters.every((filter) => this.supportTapFilterRecur(filter));
    }
    supportTapFilterRecur(filter) {
        if (filter.filterType === 'statement') {
            // cannot do string comparison on Id column
            if (filter.lhs?.name === 'Id')
                return false;
            // cannot compare column value to another column
            if (filter.rhs?.operandType === 'column')
                return false;
            return true;
        }
        // another filter group
        return filter.filters.every((filter) => this.supportTapFilterRecur(filter));
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], SalesForceImportConfig.prototype, "startDate", void 0);
SalesForceImportConfig = SalesForceImportConfig_1 = __decorate([
    JsonSchemaV2(salesForceImportConfigSchema, salesForceImportConfigSchemaValidation),
    JsonDiscriminatorValue(ImportConfigType.SalesForce)
], SalesForceImportConfig);
export { SalesForceImportConfig };
//# sourceMappingURL=salesForceImportConfig.js.map